import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4e804ce8")

_pushScopeId("data-v-4e804ce8")
const _hoisted_1 = { class: "px-3 py-5 rounded-xl border border-gray-lp-1300" }
const _hoisted_2 = { class: "w-full flex flex-col gap-4" }
const _hoisted_3 = { class: "w-full flex flex-row gap-4" }
const _hoisted_4 = { class: "w-full flex-1" }
const _hoisted_5 = { class: "w-full flex-1" }
const _hoisted_6 = { class: "w-full flex-1" }
const _hoisted_7 = {
  class: "w-full flex flex-row gap-4 flex-1 client-address-input",
  style: {"flex":"1"}
}
const _hoisted_8 = { class: "flex flex-col w-full flex-1" }
const _hoisted_9 = {
  class: "flex flex-col gap-3",
  style: {"flex":"1"}
}
const _hoisted_10 = { class: "w-full flex-1" }
const _hoisted_11 = { class: "flex flex-col w-full flex-1" }
const _hoisted_12 = {
  class: "flex flex-col gap-3",
  style: {"flex":"1"}
}
const _hoisted_13 = { class: "w-full flex-1" }
const _hoisted_14 = {
  class: "flex flex-row gap-4 flex-1 w-full",
  style: {"flex":"1"}
}
const _hoisted_15 = /*#__PURE__*/_createVNode("div", {
  class: "flex flex-col",
  style: {"flex":"1"}
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", {
  class: "flex flex-col",
  style: {"flex":"1"}
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_Select = _resolveComponent("Select")!
  const _component_managing_country_field = _resolveComponent("managing-country-field")!

  return (_openBlock(), _createBlock("section", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Title, {
        class: "mb-4",
        fontSize: 20,
        label: 
          _ctx.$t('clientManagement.registrationBranchForm.clientBranch.title')
        
      }, null, 8, ["label"]),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_DataWrapper, {
              asterisk: "",
              label: 
                _ctx.$t(
                  'clientManagement.registrationBranchForm.clientBranch.branchClientName'
                )
              ,
              fontSize: 14
            }, {
              default: _withId(() => [
                _createVNode(_component_LpInput, {
                  placeholder: 
                  _ctx.$t(
                    'clientManagement.registrationBranchForm.clientBranch.enterClientName'
                  )
                ,
                  modelValue: _ctx.modelValue.companyName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue.companyName = $event)),
                  error: _ctx.error.companyName
                }, null, 8, ["placeholder", "modelValue", "error"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_DataWrapper, {
              asterisk: "",
              label: _ctx.$t('clientManagement.managementList.columns.alias'),
              fontSize: 14
            }, {
              default: _withId(() => [
                _createVNode(_component_LpInput, {
                  placeholder: 
                  _ctx.$t('clientManagement.registrationForm.parent.enterAlias')
                ,
                  modelValue: _ctx.modelValue.companyAlias,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelValue.companyAlias = $event)),
                  error: _ctx.error.alias,
                  errorCaption: 
                  _ctx.modelValue.companyAlias && _ctx.modelValue.companyAlias.length > 3
                    ? _ctx.$t(
                        'clientManagement.registrationForm.parent.max100Characters'
                      ).toString()
                    : _ctx.$t(
                        'clientManagement.registrationForm.parent.min3Characters'
                      ).toString()
                ,
                  isUppercase: "",
                  onChange: _ctx.validateAlias,
                  id: "field_client_alias_client_registration_branch"
                }, null, 8, ["placeholder", "modelValue", "error", "errorCaption", "onChange"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('clientManagement.registrationForm.contact.phone'),
              fontSize: 14,
              asterisk: "",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_LpInput, {
                  placeholder: "Contoh: 8123456789012",
                  prefix: _ctx.phoneCodePrefix,
                  format: _ctx.formatNumber,
                  debounce: 500,
                  error: _ctx.error.phone,
                  maxLength: "12",
                  errorCaption: "Masukan No. Telepon dengan benar",
                  modelValue: _ctx.modelValue.phone,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValue.phone = $event)),
                  onChange: _ctx.validatePhone
                }, null, 8, ["prefix", "format", "error", "modelValue", "onChange"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('clientManagement.managementDetail.address'),
            fontSize: 14,
            asterisk: "",
            style: {"flex":"1"}
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                class: "w-full",
                type: "textarea",
                placeholder: 
                _ctx.$t(
                  'clientManagement.registrationBranchForm.clientBranch.enterBranchAddress'
                )
              ,
                modelValue: _ctx.modelValue.address,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.modelValue.address = $event)),
                error: _ctx.error.address
              }, null, 8, ["placeholder", "modelValue", "error"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('clientManagement.managementDetail.districtCity'),
                fontSize: 14,
                asterisk: ""
              }, {
                default: _withId(() => [
                  _createVNode(_component_SelectSearch, {
                    class: "mt-2",
                    placeholder: 
                    _ctx.$t(
                      'clientManagement.registrationBranchForm.clientBranch.enterAndSelectDistrictCity'
                    )
                  ,
                    customValueStyle: "text-sm",
                    keyValue: "id",
                    isLoading: _ctx.loadingDistrictList,
                    options: _ctx.districtList,
                    modelValue: _ctx.modelValue.district,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.modelValue.district = $event)),
                    onFilter: _ctx.fetchDistrictList,
                    onChange: _ctx.onChangeDistrict
                  }, null, 8, ["placeholder", "isLoading", "options", "modelValue", "onFilter", "onChange"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_DataWrapper, {
                label: "No. registrasi pajak (NPWP)",
                fontSize: 14,
                style: {"flex":"1"}
              }, {
                default: _withId(() => [
                  _createVNode(_component_LpInput, {
                    "data-testid": "client-branch-npwp-input",
                    placeholder: _ctx.taxPlaceholder,
                    showMaxLength: true,
                    maxLength: _ctx.taxNumberMaxLength,
                    modelValue: _ctx.modelValue.taxNumber,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.modelValue.taxNumber = $event)),
                    error: _ctx.error.taxNumber,
                    errorCaption: _ctx.error.taxNumberMessage,
                    format: _ctx.formatTaxNumber,
                    onChange: _ctx.validateTaxNumber
                  }, null, 8, ["placeholder", "maxLength", "modelValue", "error", "errorCaption", "format", "onChange"])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('clientManagement.managementDetail.email'),
                fontSize: 14,
                asterisk: ""
              }, {
                default: _withId(() => [
                  _createVNode(_component_LpInput, {
                    type: "email",
                    placeholder: 
                    _ctx.$t('clientManagement.registrationForm.contact.emailExample')
                  ,
                    modelValue: _ctx.modelValue.email,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.modelValue.email = $event)),
                    error: _ctx.error.email,
                    errorCaption: 
                    _ctx.$t('clientManagement.registrationForm.contact.invalidEmail')
                  ,
                    onChange: _ctx.validateEmail
                  }, null, 8, ["placeholder", "modelValue", "error", "errorCaption", "onChange"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('clientManagement.managementDetail.requiresSOSplit'),
                asterisk: "",
                "data-testid": "client-branch-need-split-so-field"
              }, {
                default: _withId(() => [
                  _createVNode(_component_Select, {
                    onOpenSelect: _ctx.onOpenSelectSplitSo,
                    onCloseSelect: _ctx.onCloseSelectSplitSo,
                    isOpenMenu: _ctx.isOpenSplitSo,
                    value: _ctx.modelValue.isNeedSplitSo,
                    onChooseSelect: _ctx.onSelectSplitSo,
                    dataSelect: _ctx.openSplitSoList,
                    "data-testid": "client-branch-need-split-so-dropdown",
                    class: "whitespace-no-wrap my-2"
                  }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode(_component_managing_country_field, {
            options: _ctx.managingCountryOptions,
            "model-value": _ctx.modelValue.managingCountry,
            "onUpdate:modelValue": _ctx.onSetManagingCountry
          }, null, 8, ["options", "model-value", "onUpdate:modelValue"]),
          _hoisted_15,
          _hoisted_16
        ])
      ])
    ])
  ]))
})